import {useLocation, useParams} from "react-router-dom"
import {ACCESS_TOKEN} from "common/constants/constant"

export const OAuth2Redirector = () => {
    const params = useParams()
    const location = useLocation()

    console.log("location", location, params)
    const token = params.token
    if(token) {
        localStorage.setItem(ACCESS_TOKEN, token)
        // return <Navigate replace to="/" state={{location: location}}/>
        return <div>OK</div>
    }
    // return (
    //     <Navigate to={{pathname: "/login"}} state={{from: location, error: error}}/>
    // )
    return (
        <div>NO</div>
    )
}